import type { SVGProps } from 'react';

// Filled navigation silhouettes retain clear cut-outs instead of filling the
// outlined icon paths, which would obscure details such as the home doorway.
const paths: Record<string, string> = {
  dashboard: 'M3 10 12 2l9 8v11h-6v-7H9v7H3V10Z',
  projects: 'M2 5a2 2 0 0 1 2-2h5l2 2h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Z',
  messages: 'M12 2a10 10 0 0 0-8.66 15L2 22l5-1.34A10 10 0 1 0 12 2Z',
  notifications: 'M12 2a2 2 0 0 0-2 2v.34A6 6 0 0 0 6 10v5l-2 3v1h16v-1l-2-3v-5a6 6 0 0 0-4-5.66V4a2 2 0 0 0-2-2Zm-2 19a2 2 0 0 0 4 0h-4Z',
};

export function MobileBottomNavActiveIcon({ tabId, ...props }: SVGProps<SVGSVGElement> & { tabId: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d={paths[tabId]} />
    </svg>
  );
}
